import React from "react";
import { GroupTableStyled } from "../styles";
const MemberList = React.memo(({ renderSearch, renderHeader, children }) => {
    return (React.createElement(GroupTableStyled, { isFull: true },
        renderSearch,
        React.createElement("div", { className: "table_th" }, renderHeader),
        React.createElement("div", { className: "table_body" }, children)));
});
export default MemberList;
